const colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF',
  },

  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED',
  },

  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2',
  },

  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)',
  },

  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA',
  },

  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA',
  },

  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6',
  },

  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9',
  },

  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF',
  },

  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7',
  },

  goZest: {
    base: '#e38f22',
    dark: '#AD6620',
    medium: '#EAA839',
    light: '#FDF6E9',
  },

  goRatings: {
    ratingRed: '#9b041e',
    ratingOrange: '#ed6112',
    ratingYellow: '#f59d00',
    ratingLightGreen: '#039556',
    ratingMediumGreen: '#5fa735',
    ratingDarkGreen: '#005d2f',
    taRating: '#00b087',
  },

  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)',
  },

  Numbering: {
    base: 'rgba(216, 216, 216, 0.4)',
  },
};

export function buildColors() {
  return colorPalette;
}
